import React from 'react';

import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { MFATooltipContent } from './MFATooltipContent';

type MFAIconProps = {
  containerRef?: React.RefObject<HTMLDivElement>;
};
export const MFAIcon = ({ containerRef }: MFAIconProps) => {
  return (
    <Tooltip
      triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}
      content={<MFATooltipContent />}
      renderTarget={(props) => (
        <Tooltip.Target {...props} shouldWrapChildren={false} />
      )}
      container={containerRef}
    >
      <AlertWarningIcon
        data-testid="MFAIcon"
        style={{
          margin: `auto ${theme.spacing.xSmall}px`,
          color: theme.colors.yellowOrange500,
        }}
      />
    </Tooltip>
  );
};
